module.exports = __webpack_public_path__ + "images/emoji/oncoming_bus.dcc73e39cbc575f5b042.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/oncoming_bus.png
// module id = pJxz
// module chunks = 14